import React from 'react';
import { Field } from 'redux-form';
import { ListGroupItem } from 'reactstrap';
// import '../my-portfolio.scss'

export const FilterFormCheckbox = (props) => {
    return (<ListGroupItem key={props.checkboxData}>
        <div className="custom-control custom-checkbox">
            <Field
                type="checkbox"
                className="custom-control-input m-0"
                component="input"
                name={props.checkboxData}
                id={props.checkboxData}
                value={props.checkboxData}
            />
            <label style={{ '--primaryColor': props.corporateColor }} className="custom-control-label mb-1" title={props.checkboxData} htmlFor={props.checkboxData}>{props.checkboxData}</label>
        </div>
    </ListGroupItem>)
}

export const CountryCheckboxForm = (props) => {
    return <ListGroupItem key={props.checkboxData.countryCode}>
        <div className="custom-control custom-checkbox" >
            <Field type="checkbox" component="input" className="custom-control-input m-0" name={props.checkboxData.countryName} id={props.checkboxData.countryName} />
            <label style={{ '--primaryColor': props.corporateColor }} className="custom-control-label mb-1" title={props.checkboxData.countryName} htmlFor={props.checkboxData.countryName}>{props.checkboxData.countryName}</label>
        </div>
    </ListGroupItem>
}

export const FilterFormZoneCheckbox = (props) => {
    return <ListGroupItem key={props.zoneListCheckboxData.id}>
        <div className="custom-control custom-checkbox" >
            <Field type="checkbox" component="input" className="custom-control-input m-0" name={props.zoneListCheckboxData.name} id={props.zoneListCheckboxData.name} />
            <label style={{ '--primaryColor': props.corporateColor }} className="custom-control-label mb-1" title={props.zoneListCheckboxData.name} htmlFor={props.zoneListCheckboxData.name}>{props.zoneListCheckboxData.name}</label>
        </div>
    </ListGroupItem>
}
